
<div class="assign-container fluid-container">
    <div class="top-right-div">
        <div class="top-row">
            <div class="left-titl-buton">
                <div class="title">
                    Feedback
                </div>
            </div>
            <button mat-raised-button color="primary" (click)="openFeedbackDialog()" class="btn-feedback">Submit Feedback</button>
        </div>
        <!-- <div class="sec-row">
            <div class="sr-left-div">
                <span> {{ dataSource.data.length }} Files</span>
            </div> -->
            <!-- <div class="right-filter">
                <input matInput #searchInput placeholder="Search with ..." class="filter-search">
                <i class="fa fa-search search-icon"></i>
            </div> -->
            <!-- <div *ngIf="showNoSearchResultsMessage">
                No search results found.
            </div> -->
        <!-- </div> -->
<div class="bottom-table">
    <div class="overfloxauto">
        <table  mat-table [dataSource]="dataSource" matSort 
        (matSortChange)="sortData($event)" class="assignee-table mat-elevation-z7">

          <ng-container matColumnDef="app_feedback_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="tab-th">
                Id 
            </th>
            <td mat-cell *matCellDef="let element" class="tab-td"> {{element.app_feedback_id}} </td>
        </ng-container>

        <ng-container matColumnDef="created_date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                class="tab-th">
                Date 
            </th>
            <td mat-cell *matCellDef="let element" class="tab-td"> {{ convertUtcToLocal(element.created_date) | date: 'MM-dd-yyyy hh:mm a' }} </td>
        </ng-container>

        <ng-container matColumnDef="app_feedback_topic">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                class="tab-th">
                Module
            </th>
            <td mat-cell *matCellDef="let element" class="tab-td"> {{element.app_feedback_topic}} </td>
        </ng-container>

        <ng-container matColumnDef="feedback_value">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                class="tab-th">
                Impression 
            </th>
            <td mat-cell *matCellDef="let element" class="tab-td"> {{element.feedback_value}} </td>
        </ng-container>

        <ng-container matColumnDef="app_feedback_description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"
                class="tab-th">
                Comments 
            </th>
            <td mat-cell *matCellDef="let element" class="tab-td"> {{element.app_feedback_description}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsApp"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumnsApp;"></tr>
        <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell no-data-table" colspan="9999">No data found!</td>
        </tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons></mat-paginator>

        </div>
        </div>
        </div>
        </div>
  